<template>
  <div class="proyectos-lista">
    <!-- Header -->
    <div class="content-header">
      <div class="content-header-left">
        <h1 class="content-header-title">Lista de Proyectos</h1>
        <p class="content-header-subtitle">Gestiona todos los proyectos del sistema</p>
      </div>
      <div class="content-header-right">
        <b-button variant="primary" @click="nuevoProyecto">
          <feather-icon icon="PlusIcon" size="16" class="mr-50" />
          Nuevo Proyecto
        </b-button>
      </div>
    </div>

    <!-- Filtros -->
    <b-card class="mb-3">
      <b-row>
        <b-col md="5">
          <b-form-group label="Buscar">
            <b-input-group>
              <b-form-input
                v-model="filtros.busqueda"
                placeholder="Buscar por nombre..."
                @input="filtrarProyectos"
              />
              <b-input-group-append>
                <b-button variant="outline-secondary">
                  <feather-icon icon="SearchIcon" size="16" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Estado">
            <b-form-select
              v-model="filtros.estado"
              :options="opcionesEstado"
              @change="filtrarProyectos"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Municipio">
            <b-input-group>
              <b-form-input
                v-model="filtros.municipio"
                placeholder="Buscar por municipio de obra..."
                @keyup.enter="buscarPorMunicipio"
              />
              <b-input-group-append>
                <b-button 
                  variant="outline-secondary" 
                  @click="buscarPorMunicipio"
                  :disabled="!filtros.municipio || filtros.municipio.trim() === ''"
                >
                  <feather-icon icon="MapPinIcon" size="16" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      
      <!-- Filtros de Fecha -->
      <b-row class="mt-2">
        <b-col md="3">
          <b-form-group label="Fecha Inicio Desde">
            <b-input-group>
              <b-form-input
                v-model="filtros.fechaInicioDesde"
                placeholder="dd/MM/yyyy"
                @input="filtrarProyectos"
                @blur="validarFecha('fechaInicioDesde')"
              />
              <b-input-group-append>
                <b-button 
                  variant="outline-secondary" 
                  class="calendar-button"
                  @click="mostrarCalendario('fechaInicioDesde')"
                  :disabled="mostrandoCalendario === 'fechaInicioDesde'"
                >
                  <feather-icon icon="CalendarIcon" size="16" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-modal
              :visible="mostrandoCalendario === 'fechaInicioDesde'"
              @hide="cerrarCalendario"
              title="Seleccionar Fecha"
              size="sm"
              centered
              hide-footer
            >
              <div class="calendar-modal-content">
                <b-form-group label="Fecha">
                  <b-form-input
                    v-model="fechaCalendarioInput"
                    type="date"
                    @change="onFechaInputChange('fechaInicioDesde')"
                  />
                </b-form-group>
                <div class="d-flex justify-content-end mt-3">
                  <b-button variant="secondary" @click="cerrarCalendario" class="mr-2">
                    Cancelar
                  </b-button>
                  <b-button variant="primary" @click="aplicarFecha('fechaInicioDesde')">
                    Aplicar
                  </b-button>
                </div>
              </div>
            </b-modal>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Fecha Inicio Hasta">
            <b-input-group>
              <b-form-input
                v-model="filtros.fechaInicioHasta"
                placeholder="dd/MM/yyyy"
                @input="filtrarProyectos"
                @blur="validarFecha('fechaInicioHasta')"
              />
              <b-input-group-append>
                <b-button 
                  variant="outline-secondary" 
                  class="calendar-button"
                  @click="mostrarCalendario('fechaInicioHasta')"
                  :disabled="mostrandoCalendario === 'fechaInicioHasta'"
                >
                  <feather-icon icon="CalendarIcon" size="16" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-modal
              :visible="mostrandoCalendario === 'fechaInicioHasta'"
              @hide="cerrarCalendario"
              title="Seleccionar Fecha"
              size="sm"
              centered
              hide-footer
            >
              <div class="calendar-modal-content">
                <b-form-group label="Fecha">
                  <b-form-input
                    v-model="fechaCalendarioInput"
                    type="date"
                    @change="onFechaInputChange('fechaInicioHasta')"
                  />
                </b-form-group>
                <div class="d-flex justify-content-end mt-3">
                  <b-button variant="secondary" @click="cerrarCalendario" class="mr-2">
                    Cancelar
                  </b-button>
                  <b-button variant="primary" @click="aplicarFecha('fechaInicioHasta')">
                    Aplicar
                  </b-button>
                </div>
              </div>
            </b-modal>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Fecha Fin Desde">
            <b-input-group>
              <b-form-input
                v-model="filtros.fechaFinDesde"
                placeholder="dd/MM/yyyy"
                @input="filtrarProyectos"
                @blur="validarFecha('fechaFinDesde')"
              />
              <b-input-group-append>
                <b-button 
                  variant="outline-secondary" 
                  class="calendar-button"
                  @click="mostrarCalendario('fechaFinDesde')"
                  :disabled="mostrandoCalendario === 'fechaFinDesde'"
                >
                  <feather-icon icon="CalendarIcon" size="16" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-modal
              :visible="mostrandoCalendario === 'fechaFinDesde'"
              @hide="cerrarCalendario"
              title="Seleccionar Fecha"
              size="sm"
              centered
              hide-footer
            >
              <div class="calendar-modal-content">
                <b-form-group label="Fecha">
                  <b-form-input
                    v-model="fechaCalendarioInput"
                    type="date"
                    @change="onFechaInputChange('fechaFinDesde')"
                  />
                </b-form-group>
                <div class="d-flex justify-content-end mt-3">
                  <b-button variant="secondary" @click="cerrarCalendario" class="mr-2">
                    Cancelar
                  </b-button>
                  <b-button variant="primary" @click="aplicarFecha('fechaFinDesde')">
                    Aplicar
                  </b-button>
                </div>
              </div>
            </b-modal>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Fecha Fin Hasta">
            <b-input-group>
              <b-form-input
                v-model="filtros.fechaFinHasta"
                placeholder="dd/MM/yyyy"
                @input="filtrarProyectos"
                @blur="validarFecha('fechaFinHasta')"
              />
              <b-input-group-append>
                <b-button 
                  variant="outline-secondary" 
                  class="calendar-button"
                  @click="mostrarCalendario('fechaFinHasta')"
                  :disabled="mostrandoCalendario === 'fechaFinHasta'"
                >
                  <feather-icon icon="CalendarIcon" size="16" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-modal
              :visible="mostrandoCalendario === 'fechaFinHasta'"
              @hide="cerrarCalendario"
              title="Seleccionar Fecha"
              size="sm"
              centered
              hide-footer
            >
              <div class="calendar-modal-content">
                <b-form-group label="Fecha">
                  <b-form-input
                    v-model="fechaCalendarioInput"
                    type="date"
                    @change="onFechaInputChange('fechaFinHasta')"
                  />
                </b-form-group>
                <div class="d-flex justify-content-end mt-3">
                  <b-button variant="secondary" @click="cerrarCalendario" class="mr-2">
                    Cancelar
                  </b-button>
                  <b-button variant="primary" @click="aplicarFecha('fechaFinHasta')">
                    Aplicar
          </b-button>
                </div>
              </div>
            </b-modal>
          </b-form-group>
        </b-col>
      </b-row>
      
      <!-- Botón Limpiar Filtros -->
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button variant="outline-secondary" @click="limpiarFiltros">
            <feather-icon icon="RefreshCwIcon" size="16" class="mr-1" />
            Limpiar Filtros
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <!-- Tabla de Proyectos -->
    <b-card>
      <b-table
        :items="proyectosFiltrados"
        :fields="proyectosFields"
        responsive
        striped
        hover
        :busy="cargando"
        show-empty
        empty-text="No se encontraron proyectos"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Cargando...</strong>
          </div>
        </template>

        <template #cell(estado)="data">
          <b-badge
            :variant="getEstadoVariant(data.item.estado)"
            class="text-capitalize"
          >
            {{ data.item.estado }}
          </b-badge>
        </template>

        <template #cell(progreso)="data">
          <div class="d-flex align-items-center">
            <b-progress
              :value="data.item.progreso"
              :max="100"
              class="flex-grow-1 mr-2"
              height="8px"
            />
            <span class="text-muted">{{ data.item.progreso }}%</span>
          </div>
        </template>

        <template #cell(fechaInicio)="data">
          {{ formatearFecha(data.item.fechaInicio) }}
        </template>

        <template #cell(fechaFin)="data">
          {{ formatearFecha(data.item.fechaFin) }}
        </template>

        <template #cell(acciones)="data">
          <b-button-group size="sm">
            <b-button
              variant="outline-primary"
              @click="verProyecto(data.item.id)"
            >
              <feather-icon icon="EyeIcon" size="14" />
            </b-button>
            <b-button
              variant="outline-warning"
              @click="editarProyecto(data.item.id)"
            >
              <feather-icon icon="EditIcon" size="14" />
            </b-button>
            <b-button
              variant="outline-danger"
              @click="eliminarProyecto(data.item.id)"
            >
              <feather-icon icon="TrashIcon" size="14" />
            </b-button>
          </b-button-group>
        </template>
      </b-table>

      <!-- Paginación -->
      <div class="d-flex justify-content-between align-items-center mt-3">
        <div>
          <span class="text-muted">
            Mostrando {{ proyectosFiltrados.length }} de {{ proyectos.length }} proyectos
          </span>
        </div>
        <b-pagination
          v-model="paginacion.paginaActual"
          :total-rows="paginacion.totalFilas"
          :per-page="paginacion.filasPorPagina"
          @change="cambiarPagina"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import { EstadoProyectoService } from '@/services/estadoProyectoService'
import { ProyectoService } from '@/services/proyectoService'

export default {
  name: 'ProyectosLista',
  data() {
    return {
      cargando: false,
      filtros: {
        busqueda: '',
        estado: '',
        municipio: '',
        fechaInicioDesde: '',
        fechaInicioHasta: '',
        fechaFinDesde: '',
        fechaFinHasta: '',
      },
      opcionesEstado: [
        { value: '', text: 'Todos los estados' },
      ],
      estadosProyectos: [],
      proyectosFields: [
        { key: 'nombre', label: 'Nombre', sortable: true },
        { key: 'estado', label: 'Estado', sortable: true },
        { key: 'progreso', label: 'Progreso', sortable: true },
        { key: 'fechaInicio', label: 'Fecha Inicio', sortable: true },
        { key: 'fechaFin', label: 'Fecha Fin', sortable: true },
        { key: 'acciones', label: 'Acciones' },
      ],
      proyectos: [],
      busquedaMunicipioActiva: false,
      paginacion: {
        paginaActual: 1,
        filasPorPagina: 10,
        totalFilas: 0,
      },
      mostrandoCalendario: null,
      fechaCalendario: null,
      fechaCalendarioInput: '',
    }
  },
  mounted() {
    this.cargarEstadosProyectos()
  },
  computed: {
    proyectosFiltrados() {
      let proyectos = this.proyectos

      if (this.filtros.busqueda) {
        const busqueda = this.filtros.busqueda.toLowerCase()
        proyectos = proyectos.filter(proyecto =>
          proyecto.nombre.toLowerCase().includes(busqueda)
        )
      }

      if (this.filtros.estado) {
        proyectos = proyectos.filter(proyecto => proyecto.estado === this.filtros.estado)
      }

      // Filtros de fecha
      if (this.filtros.fechaInicioDesde) {
        const fechaDesde = this.parsearFecha(this.filtros.fechaInicioDesde)
        if (fechaDesde) {
          const fechaDesdeNormalizada = this.normalizarFecha(fechaDesde)
          console.log('Filtrando fecha inicio desde:', fechaDesdeNormalizada)
          proyectos = proyectos.filter(proyecto => {
            if (!proyecto.fechaInicio) {
              console.log('Proyecto sin fecha inicio:', proyecto.nombre)
              return false
            }
            const fechaProyectoNormalizada = this.normalizarFecha(proyecto.fechaInicio)
            console.log('Comparando:', fechaProyectoNormalizada, '>=', fechaDesdeNormalizada, '=', fechaProyectoNormalizada >= fechaDesdeNormalizada)
            return fechaProyectoNormalizada >= fechaDesdeNormalizada
          })
        }
      }

      if (this.filtros.fechaInicioHasta) {
        const fechaHasta = this.parsearFecha(this.filtros.fechaInicioHasta)
        if (fechaHasta) {
          const fechaHastaNormalizada = this.normalizarFecha(fechaHasta)
          console.log('Filtrando fecha inicio hasta:', fechaHastaNormalizada)
          proyectos = proyectos.filter(proyecto => {
            if (!proyecto.fechaInicio) {
              console.log('Proyecto sin fecha inicio:', proyecto.nombre)
              return false
            }
            const fechaProyectoNormalizada = this.normalizarFecha(proyecto.fechaInicio)
            console.log('Comparando:', fechaProyectoNormalizada, '<=', fechaHastaNormalizada, '=', fechaProyectoNormalizada <= fechaHastaNormalizada)
            return fechaProyectoNormalizada <= fechaHastaNormalizada
          })
        }
      }

      if (this.filtros.fechaFinDesde) {
        const fechaDesde = this.parsearFecha(this.filtros.fechaFinDesde)
        if (fechaDesde) {
          const fechaDesdeNormalizada = this.normalizarFecha(fechaDesde)
          console.log('Filtrando fecha fin desde:', fechaDesdeNormalizada)
          proyectos = proyectos.filter(proyecto => {
            if (!proyecto.fechaFin) {
              console.log('Proyecto sin fecha fin:', proyecto.nombre)
              return false
            }
            const fechaProyectoNormalizada = this.normalizarFecha(proyecto.fechaFin)
            console.log('Comparando:', fechaProyectoNormalizada, '>=', fechaDesdeNormalizada, '=', fechaProyectoNormalizada >= fechaDesdeNormalizada)
            return fechaProyectoNormalizada >= fechaDesdeNormalizada
          })
        }
      }

      if (this.filtros.fechaFinHasta) {
        const fechaHasta = this.parsearFecha(this.filtros.fechaFinHasta)
        if (fechaHasta) {
          const fechaHastaNormalizada = this.normalizarFecha(fechaHasta)
          console.log('Filtrando fecha fin hasta:', fechaHastaNormalizada)
          proyectos = proyectos.filter(proyecto => {
            if (!proyecto.fechaFin) {
              console.log('Proyecto sin fecha fin:', proyecto.nombre)
              return false
            }
            const fechaProyectoNormalizada = this.normalizarFecha(proyecto.fechaFin)
            console.log('Comparando:', fechaProyectoNormalizada, '<=', fechaHastaNormalizada, '=', fechaProyectoNormalizada <= fechaHastaNormalizada)
            return fechaProyectoNormalizada <= fechaHastaNormalizada
          })
        }
      }

      // Filtro por municipio (local) solo si NO se ha hecho búsqueda por backend
      if (!this.busquedaMunicipioActiva && this.filtros.municipio && this.filtros.municipio.trim() !== '') {
        const municipioFiltro = this.filtros.municipio.toLowerCase().trim()
        proyectos = proyectos.filter(proyecto =>
          (proyecto.municipio || '').toLowerCase().includes(municipioFiltro)
        )
      }

      this.paginacion.totalFilas = proyectos.length
      return proyectos
    },
  },
  async mounted() {
    await this.cargarEstadosProyectos()
    await this.cargarProyectos()
  },
  methods: {
    async cargarProyectos() {
      this.cargando = true
      try {
        console.log('Cargando proyectos desde el backend...')
        const proyectos = await ProyectoService.getAll()
        console.log('Proyectos cargados:', proyectos)
        
        // Mapear los datos del backend al formato esperado por la vista
        this.proyectos = proyectos.map(proyecto => {
          console.log('Proyecto del backend:', proyecto.nombre, 'fechaInicio:', proyecto.fechaInicio, 'fechaFin:', proyecto.fechaFin)
          return {
          id: proyecto.idProyecto,
          nombre: proyecto.nombre,
          estado: this.getNombreEstado(proyecto.idEstadoProyecto),
          progreso: proyecto.progreso || 0, // Si no hay campo progreso en el backend
          fechaInicio: proyecto.fechaInicio,
          fechaFin: proyecto.fechaFin,
          descripcion: proyecto.descripcion,
          presupuesto: proyecto.presupuesto,
          responsable: proyecto.responsable,
          municipio: proyecto.municipio || 'Sin municipio' // Municipio de las obras del proyecto
          }
        })
        
        console.log('Proyectos mapeados:', this.proyectos)
      } catch (error) {
        console.error('Error al cargar proyectos:', error)
        this.$toast({
          component: {
            template: '<div>Error al cargar los proyectos</div>',
          },
          props: {
            variant: 'danger',
          },
        })
      } finally {
        this.cargando = false
      }
    },
    filtrarProyectos() {
      // Los filtros se aplican automáticamente por el computed
      // Solo se aplican filtros locales (búsqueda, estado, cliente)
    },
    
    async buscarPorMunicipio() {
      if (!this.filtros.municipio || this.filtros.municipio.trim() === '') {
        return
      }
      
      try {
        this.cargando = true
        const proyectosFiltrados = await ProyectoService.searchByMunicipio(this.filtros.municipio)
        this.busquedaMunicipioActiva = true
        
        // Aplicar otros filtros localmente
        let proyectos = proyectosFiltrados.map(proyecto => ({
          id: proyecto.idProyecto,
          nombre: proyecto.nombre,
          estado: this.getNombreEstado(proyecto.idEstadoProyecto),
          progreso: proyecto.progreso || 0,
          fechaInicio: proyecto.fechaInicio,
          fechaFin: proyecto.fechaFin,
          descripcion: proyecto.descripcion,
          presupuesto: proyecto.presupuesto,
          responsable: proyecto.responsable,
          municipio: proyecto.municipio || 'Sin municipio'
        }))
        
        // Aplicar filtros adicionales
        if (this.filtros.busqueda) {
          const busqueda = this.filtros.busqueda.toLowerCase()
          proyectos = proyectos.filter(proyecto =>
            proyecto.nombre.toLowerCase().includes(busqueda)
          )
        }
        
        if (this.filtros.estado) {
          proyectos = proyectos.filter(proyecto => proyecto.estado === this.filtros.estado)
        }
        
        // Aplicar filtros de fecha
        if (this.filtros.fechaInicioDesde) {
          const fechaDesde = this.parsearFecha(this.filtros.fechaInicioDesde)
          if (fechaDesde) {
            const fechaDesdeNormalizada = this.normalizarFecha(fechaDesde)
            proyectos = proyectos.filter(proyecto => {
              if (!proyecto.fechaInicio) return false
              const fechaProyectoNormalizada = this.normalizarFecha(proyecto.fechaInicio)
              return fechaProyectoNormalizada >= fechaDesdeNormalizada
            })
          }
        }

        if (this.filtros.fechaInicioHasta) {
          const fechaHasta = this.parsearFecha(this.filtros.fechaInicioHasta)
          if (fechaHasta) {
            const fechaHastaNormalizada = this.normalizarFecha(fechaHasta)
            proyectos = proyectos.filter(proyecto => {
              if (!proyecto.fechaInicio) return false
              const fechaProyectoNormalizada = this.normalizarFecha(proyecto.fechaInicio)
              return fechaProyectoNormalizada <= fechaHastaNormalizada
            })
          }
        }

        if (this.filtros.fechaFinDesde) {
          const fechaDesde = this.parsearFecha(this.filtros.fechaFinDesde)
          if (fechaDesde) {
            const fechaDesdeNormalizada = this.normalizarFecha(fechaDesde)
            proyectos = proyectos.filter(proyecto => {
              if (!proyecto.fechaFin) return false
              const fechaProyectoNormalizada = this.normalizarFecha(proyecto.fechaFin)
              return fechaProyectoNormalizada >= fechaDesdeNormalizada
            })
          }
        }

        if (this.filtros.fechaFinHasta) {
          const fechaHasta = this.parsearFecha(this.filtros.fechaFinHasta)
          if (fechaHasta) {
            const fechaHastaNormalizada = this.normalizarFecha(fechaHasta)
            proyectos = proyectos.filter(proyecto => {
              if (!proyecto.fechaFin) return false
              const fechaProyectoNormalizada = this.normalizarFecha(proyecto.fechaFin)
              return fechaProyectoNormalizada <= fechaHastaNormalizada
            })
          }
        }
        
        this.proyectos = proyectos
        
        this.$toast({
          component: {
            template: `<div>Se encontraron ${proyectos.length} proyectos en el municipio "${this.filtros.municipio}"</div>`,
          },
          props: {
            variant: 'success',
          },
        })
      } catch (error) {
        console.error('Error al buscar por municipio:', error)
        this.$toast({
          component: {
            template: '<div>Error al buscar por municipio</div>',
          },
          props: {
            variant: 'danger',
          },
        })
      } finally {
        this.cargando = false
      }
    },
    async limpiarFiltros() {
      this.filtros = {
        busqueda: '',
        estado: '',
        municipio: '',
        fechaInicioDesde: '',
        fechaInicioHasta: '',
        fechaFinDesde: '',
        fechaFinHasta: '',
      }
      this.busquedaMunicipioActiva = false
      // Recargar todos los proyectos cuando se limpian los filtros
      await this.cargarProyectos()
    },
    getEstadoVariant(estado) {
      const variants = {
        'En Progreso': 'primary',
        'Completado': 'success',
        'Pendiente': 'warning',
        'Cancelado': 'danger',
      }
      return variants[estado] || 'secondary'
    },
    verProyecto(id) {
      this.$router.push({ name: 'proyectos-detalle', params: { id } })
    },
    editarProyecto(id) {
      this.$router.push({ name: 'proyectos-editar', params: { id } })
    },
    eliminarProyecto(id) {
      this.$swal({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            await ProyectoService.delete(id)
            this.$toast({
              component: {
                template: '<div>Proyecto eliminado correctamente</div>',
              },
              props: {
                variant: 'success',
              },
            })
            // Recargar la lista de proyectos
            await this.cargarProyectos()
          } catch (error) {
            console.error('Error al eliminar proyecto:', error)
            this.$toast({
              component: {
                template: '<div>Error al eliminar el proyecto</div>',
              },
              props: {
                variant: 'danger',
              },
            })
          }
        }
      })
    },
    getNombreEstado(idEstado) {
      const estado = this.estadosProyectos.find(e => e.idEstadoProyecto === idEstado)
      return estado ? estado.nombre : 'Sin estado'
    },
    
    async cargarEstadosProyectos() {
      try {
        const estados = await EstadoProyectoService.getAll()
        this.estadosProyectos = estados
        this.opcionesEstado = [
          { value: '', text: 'Todos los estados' },
          ...estados.map(estado => ({
            value: estado.nombre,
            text: estado.nombre
          }))
        ]
        console.log('Estados de proyectos cargados:', estados)
      } catch (error) {
        console.error('Error al cargar estados de proyectos:', error)
      }
    },
    nuevoProyecto() {
      this.$router.push({ name: 'proyectos-nuevo' })
    },
    cambiarPagina(pagina) {
      this.paginacion.paginaActual = pagina
    },
    
    // Utilidades para formateo de fechas
    formatearFecha(fecha) {
      if (!fecha) return ''
      const date = new Date(fecha)
      if (isNaN(date.getTime())) return fecha
      
      const dia = date.getDate().toString().padStart(2, '0')
      const mes = (date.getMonth() + 1).toString().padStart(2, '0')
      const año = date.getFullYear()
      
      return `${dia}/${mes}/${año}`
    },
    
    parsearFecha(fechaString) {
      if (!fechaString || fechaString.trim() === '') return null
      
      // Validar formato dd/MM/yyyy
      const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/
      const match = fechaString.match(regex)
      
      if (!match) return null
      
      const [, dia, mes, año] = match
      const fecha = new Date(año, mes - 1, dia)
      
      // Verificar que la fecha es válida
      if (fecha.getDate() != dia || fecha.getMonth() != mes - 1 || fecha.getFullYear() != año) {
        return null
      }
      
      return fecha
    },
    
    // Función para normalizar fechas (solo día, mes, año)
    normalizarFecha(fecha) {
      if (!fecha) return null
      const date = new Date(fecha)
      if (isNaN(date.getTime())) return null
      
      // Crear una nueva fecha con solo año, mes y día (sin horas)
      return new Date(date.getFullYear(), date.getMonth(), date.getDate())
    },
    
    validarFecha(campo) {
      const valor = this.filtros[campo]
      if (!valor || valor.trim() === '') return
      
      const fecha = this.parsearFecha(valor)
      if (!fecha) {
        this.$toast({
          component: {
            template: `<div>Formato de fecha inválido. Use dd/MM/yyyy</div>`,
          },
          props: {
            variant: 'warning',
          },
        })
        this.filtros[campo] = ''
      }
    },
    
    // Métodos para el calendario
    mostrarCalendario(campo) {
      this.mostrandoCalendario = campo
      
      // Si ya hay una fecha en el campo, mostrarla en el input
      const fechaActual = this.filtros[campo]
      if (fechaActual) {
        const fecha = this.parsearFecha(fechaActual)
        if (fecha) {
          // Convertir a formato YYYY-MM-DD para el input date
          this.fechaCalendarioInput = fecha.toISOString().split('T')[0]
        } else {
          this.fechaCalendarioInput = ''
        }
      } else {
        this.fechaCalendarioInput = ''
      }
    },
    
    onFechaSeleccionada(campo, event) {
      if (event.selectedDate) {
        const fecha = new Date(event.selectedDate)
        const fechaFormateada = this.formatearFecha(fecha)
        this.filtros[campo] = fechaFormateada
        this.mostrandoCalendario = null
        this.fechaCalendario = null
        this.filtrarProyectos()
      }
    },
    
    cerrarCalendario() {
      this.mostrandoCalendario = null
      this.fechaCalendario = null
      this.fechaCalendarioInput = ''
    },
    
    onFechaInputChange(campo) {
      // Este método se ejecuta cuando cambia el input de fecha
      // No necesitamos hacer nada aquí, solo cuando se aplique
    },
    
    aplicarFecha(campo) {
      if (this.fechaCalendarioInput) {
        const fecha = new Date(this.fechaCalendarioInput)
        const fechaFormateada = this.formatearFecha(fecha)
        this.filtros[campo] = fechaFormateada
        this.cerrarCalendario()
        this.filtrarProyectos()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.proyectos-lista {
  padding: 1.5rem;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.content-header-title {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.content-header-subtitle {
  color: #6c757d;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .content-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .content-header-right {
    margin-top: 1rem;
  }
}

// Estilos para los calendarios
.calendar-modal-content {
  padding: 1rem 0;
}

.calendar-modal-content .form-group {
  margin-bottom: 1rem;
}

.calendar-button {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  transition: all 0.2s ease;
}

.calendar-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.calendar-button:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

</style>
